let deviceType: 'MSITE' | 'WEBSITE' = 'MSITE';

export const setDeviceType = (newDeviceType: 'MSITE' | 'WEBSITE') => {
  deviceType = newDeviceType;
};

export const getDeviceType = () => deviceType;

export const getDomain = () => 'NYKAA_FASHION';
